type Props = {
  count: number;
  countText: number;
  description: string;
  Icon: (props: { className?: string }) => JSX.Element;
};

export default function SelectScreenInfo({ count, countText, description, Icon }: Props) {
  return (
    <div className="flex justify-between items-center h-13">
      <p className="text-15 font-medium text-white/30">{description}</p>
      <div className="flex items-center">
        <Icon className="size-4.5 text-white/10" />
        <p className="ml-2.5 mr-1 text-12 font-bold uppercase">{countText}</p>
        <p className="flex justify-center items-center h-5.5 px-1.5 py-[0.44rem] text-12 font-bold bg-white/5 rounded-md">
          {count}
        </p>
      </div>
    </div>
  );
}
